import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import './index.scss';
import { isEmpty as _isEmpty } from 'lodash';
import classnames from 'classnames';

import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import { useNavigate, useLocation } from 'react-router-dom';
import { t } from 'i18next';
import { useMobxStores } from '@stores/store';
import { cookiesDialogData } from '@molecules/data/consent/cookies.dialog';
import { cookiesAllConsent } from '@molecules/data/consent/cookies.all.consent';
import { consentCookiesKey } from '@stores/SettingStore';

import { getArrayFromJson, saveConsentCookiesTimes } from '@helpers/Util';

const GdprAccordion = ({ data, faqIdx }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const consentCookieData = localStorage.getItem(consentCookiesKey.cookies);

  const { settingStore } = useMobxStores();
  const [activeIdx, setActiveIdx] = useState(null);
  const [selectedBoxes, setSelectedBoxes] = useState(
    getArrayFromJson(consentCookieData)
  );

  console.log(selectedBoxes);
  const htmlAllData = ['en', 'jp', 'kr'].includes(i18n.language)
    ? cookiesAllConsent[i18n.language]
    : cookiesAllConsent['kr'];

  const onToggle = (e, idx) => {
    setActiveIdx(idx);
  };

  const onCheckedAll = e => {
    console.log(e.target.checked);

    if (e.target.checked) {
      const checkedListArray = [];
      cookiesDialogData.forEach(e =>
        e.isUse ? checkedListArray.push(e.type) : ''
      );
      setSelectedBoxes(checkedListArray);
    } else {
      setSelectedBoxes([]);
    }
    console.log(selectedBoxes);
  };

  const onChecked = e => {
    if (e.target.checked) {
      setSelectedBoxes([...selectedBoxes, e.target.value]);
    } else {
      setSelectedBoxes(selectedBoxes.filter(el => el !== e.target.value));
    }
    console.log(selectedBoxes);
  };

  const onSave = () => {
    localStorage.setItem(
      consentCookiesKey.cookies,
      JSON.stringify(selectedBoxes)
    );
    saveConsentCookiesTimes();
    settingStore.setGdprDialogState(false);
    settingStore.setGdprDetailDialogState(false);
  };

  const onDisagree = () => {
    localStorage.setItem(consentCookiesKey.cookies, JSON.stringify([]));
    saveConsentCookiesTimes();
    settingStore.setGdprDialogState(false);
    settingStore.setGdprDetailDialogState(false);
  };

  // https://developers.facebook.com/docs/meta-pixel/implementation/gdpr

  return (
    <div>
      <ul>
        <li>
          <input
            onChange={e => onToggle(e, 999)}
            className="accordion-input hidden"
            type="checkbox"
            id={`accordion-999`}
          />
          <label
            htmlFor={`accordion-999`}
            className={classnames(
              'accordion__label',
              'text-left gap-x-[5px] cursor-pointer gap-y-[5px] py-[24px] items-center bg-white relative',
              'xl:gap-x-[16px] xl:py-[30px] text-primary'
            )}
          >
            <div className={classnames('accordion__label-title')}>
              <div className={classnames('font-TmoneyRoundWind font-bold ')}>
                <label htmlFor={`agreement-all`} key={`agreement-all`}>
                  <i
                    className={classnames(
                      'text-black inline-block pr-3 text-xl'
                    )}
                  >
                    <input
                      onChange={onCheckedAll}
                      className={classnames('accordion-input border-1 ')}
                      type="checkbox"
                      checked={selectedBoxes.length >= 2}
                      id={`agreement-all`}
                      name={`agreement-all`}
                      defaultValue={'all'}
                    />
                  </i>
                  {t('전체 동의')}
                </label>
              </div>
            </div>
            <div
              className={classnames(
                'accordion__label-content',
                'text-[14px] font-Pretendard font-bold tracking-[-0.07px] break-all',
                'xl:text-[20px]'
              )}
              style={{ wordBreak: 'break-all' }}
            ></div>
            <div className={classnames('accordion__label-arrow')}>
              <div
                className={classnames('text-[18px]', 'xl:text-[28px] pr-10')}
              >
                <i className="icon-arrow text-black inline-block font-extrabold"></i>
              </div>
            </div>
            <div className="accordion__label-divider absolute bottom-0 left-0 h-px bg-[#f4f6fa]"></div>
          </label>

          <div className="accordion-content bg-[#f4f6fa]">
            <div className=" flex gap-x-[20px] gap-y-[13px] flex-col xl:flex-row border-y border-[color:#e6eaf2] max-h-[130px] overflow-y-auto">
              <div
                className=" text-left  whitespace-pre-line py-5 px-14"
                dangerouslySetInnerHTML={{
                  __html: htmlAllData,
                }}
              ></div>
            </div>
          </div>
        </li>
        {!_isEmpty(cookiesDialogData) &&
          cookiesDialogData.map((gdpr, i) => (
            <li key={`gdpr_${i}`}>
              <input
                onChange={e => onToggle(e, gdpr.idx)}
                className="accordion-input hidden"
                type="checkbox"
                id={`accordion-${i}`}
              />
              <label
                htmlFor={`accordion-${i}`}
                className={classnames(
                  'accordion__label',
                  'text-left gap-x-[5px] gap-y-[5px] py-[24px] items-center bg-white relative',
                  'xl:gap-x-[16px] xl:py-[30px]',
                  {
                    'cursor-pointer': gdpr.isUse,
                  }
                )}
              >
                <div className={classnames('accordion__label-title')}>
                  <div
                    className={classnames('font-TmoneyRoundWind font-bold ', {
                      'text-[#ddd]': !gdpr.isUse,
                    })}
                  >
                    <label htmlFor={`agreement-${i}`} key={`agreement-${i}`}>
                      <i
                        className={classnames(
                          'text-black inline-block pr-3 text-xl'
                        )}
                      >
                        <input
                          onChange={onChecked}
                          className={classnames('accordion-input border-1 ', {
                            'border-[#d6d9e0]': !gdpr.isUse,
                          })}
                          type="checkbox"
                          checked={selectedBoxes.includes(gdpr.type)}
                          id={`agreement-${i}`}
                          name={`agreement-${i}`}
                          disabled={!gdpr.isUse}
                          defaultValue={gdpr.type}
                        />
                      </i>
                      {t(gdpr.title)}
                    </label>
                  </div>
                </div>
                {gdpr.contents && (
                  <>
                    <div
                      className={classnames(
                        'accordion__label-content',
                        'text-[14px] font-Pretendard font-bold tracking-[-0.07px] break-all',
                        'xl:text-[20px]'
                      )}
                      style={{ wordBreak: 'break-all' }}
                    ></div>
                    <div className={classnames('accordion__label-arrow')}>
                      <div
                        className={classnames(
                          'text-[18px]',
                          'xl:text-[28px] pr-10'
                        )}
                      >
                        <i className="icon-arrow text-black inline-block "></i>
                      </div>
                    </div>
                    <div className="accordion__label-divider absolute bottom-0 left-0 h-px bg-[#f4f6fa]"></div>
                  </>
                )}
              </label>

              {gdpr.contents && (
                <div className="accordion-content bg-[#f4f6fa]">
                  <div className="p-[30px] flex gap-x-[20px] gap-y-[13px] flex-col xl:flex-row border-y border-[color:#e6eaf2]">
                    <div className="text-left p-4">
                      <p>{t(gdpr.contents)}</p>
                      <a
                        className={'underline font-bold mt-5'}
                        href={`/${i18n.language}/policy/cookies`}
                      >
                        {t('쿠키 보기')}
                      </a>
                    </div>
                  </div>
                </div>
              )}
            </li>
          ))}
      </ul>

      <div className={'grid grid-cols-2 grid-flow-col gap-4 p-3'}>
        <button
          onClick={onDisagree}
          className="font-bold text-black p-3 rounded"
        >
          <span>{t('모두 거부')}</span>
        </button>

        <button onClick={onSave} className="font-bold text-primary p-3 rounded">
          <span>{t('저장')}</span>
        </button>
      </div>
    </div>
  );
};

export default observer(GdprAccordion);
